import React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import History from "../../utilities/History";
import * as CONSTANTS from "../../utilities/Constants";
import { v4 as uuidv4 } from "uuid";
import propertyListStore from "../../flux/stores/property/ListStore";
import { Button, Dialog, Input } from "@abb/abb-common-ux-react";
import TableComponent from "../shared/TableComponent";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import PropertyViewData, {
  IPropertyViewData,
} from "../../models/property/PropertyViewData";
import IInstrumentTypeFormData from "../../models/instrumentType/InstrumentTypeFormData";
import propertyTypeActions from "../../flux/actions/PropertyTypeActions";
import instrumentActions from "../../flux/actions/InstrumentActions";
import propertyTypeListStore from "../../flux/stores/propertyType/ListStore";
import getPropertyStore from "../../flux/stores/instrument/GetPropertyStore";
import IPropertyType from "../../models/propertyType/PropertyTypeData";
import triggerNotifications from "../../utilities/TriggerNotifications";
import propertyActions from "../../flux/actions/PropertyActions";
import { Translation } from "react-i18next";
import IPropertyFormData from "../../models/property/PropertyFormData";
import { PropertyFormData } from "../../models/property/PropertyFormData";
import i18next from "i18next";

// Todo: Understand
type PropsType = RouteComponentProps & {};
// End

interface IState {
  list: IPropertyViewData[];
  selected: string[];
  previousState: IInstrumentTypeFormData;
  isCreatePropertyOpen: boolean;
  propertyName: string;
  propertyCustomId: string;
  propertyUnit: string;
  propertyDecimals: number;
  propertyTypeId: string;
  propertyDescription: string;
  propertyTypes: IPropertyType[];
  propertyFormData: IPropertyFormData;
  nameError: boolean;
  customIdError: boolean;
  propertySearchValue: string;
}

class AssociateProperty extends React.Component<PropsType, IState> {
  _mount: boolean;
  _columns: IColumnHeaderData[];
  private _propertyData: any;

  constructor(props: PropsType) {
    super(props);

    const previousState = this.props.location.state as IInstrumentTypeFormData;
    const createData = new PropertyFormData(
      false,
      uuidv4(),
      CONSTANTS.DefaultGuid,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      [],
      [],
      { formula: "", variables: [] }
    );
    this.state = {
      list: [],
      selected: previousState.properties.map((d) => d.id),
      previousState,
      isCreatePropertyOpen: false,
      propertyName: "",
      propertyCustomId: "",
      propertyUnit: "",
      propertyDecimals: 0,
      propertyTypeId: "",
      propertyDescription: "",
      propertyTypes: [],
      propertyFormData: createData,
      nameError: false,
      customIdError: false,
      propertySearchValue: "",
    };

    this._mount = false;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    propertyActions.getAllMeasuredProperties().then();

    propertyListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        const _list: any[] = [];
        const receivedData =
          state.propertyDataList && state.propertyDataList.result
            ? (state.propertyDataList.result as IPropertyViewData[])
            : [];
        receivedData.forEach((element: IPropertyViewData) => {
          _list.push({
            id: element.id,
            name: element.name,
            customId: element.customId,
            unit: element.unit,
            description: element.description,
            decimal: element.decimal,
            typeId: element.typeId,
            type: element.type,
          });
        });
        this.setState({ list: _list });
      }
    });

    propertyTypeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        var filteredValue = state.propertyTypeData.filter(
          (i: any) => i.name === "Measured"
        );
        this.setState({
          propertyTypes: filteredValue,
          propertyTypeId: filteredValue[0].id,
        });
      }
    });

    getPropertyStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._propertyData = state.data.data;
      }
    });
    instrumentActions.getPropertyDetails().then()
  }

  private onCreatePropertyClick = () => {
    this.setState({
      isCreatePropertyOpen: true,
    });
  };

  private onCreatePropertyOkClick = () => {
    if (
      this.state.propertyName === "" ||
      this.state.propertyCustomId === "" ||
      this.state.propertyCustomId === "0" ||
      this.state.propertyTypeId === CONSTANTS.DefaultGuid ||
      this.state.customIdError || this.state.nameError
    ) {
      triggerNotifications.error(i18next.t("Required fields missing."));
      return;
    } else {
      const propFilter = this._propertyData?.filter((item:any) => {
        return Number(this.state.propertyCustomId) === item.id
      })
      if(propFilter?.length !== 0){
        triggerNotifications.error(
          i18next.t("Property with same Id already exists")
        );
        return;
      }
    }

    const selectedPropertyType = this.state.propertyTypes.find(
      (d) => d.id === this.state.propertyTypeId
    ) as IPropertyType;
    const newId = "new" + uuidv4();
    const newItem = new PropertyViewData(
      newId,
      this.state.propertyName,
      this.state.propertyDescription,
      Number(this.state.propertyCustomId),
      selectedPropertyType.name,
      selectedPropertyType.id,
      this.state.propertyUnit,
      this.state.propertyDecimals
    );
    const _list = this.state.list;
    _list.unshift(newItem);
    this.setState({
      list: _list,
      selected: [...this.state.selected, newId],
      isCreatePropertyOpen: false,
    });
  };

  private handleOnSelect = (row: any, isSelect: boolean) => {
    if (isSelect) {
      this.setState(() => ({
        selected: [...this.state.selected, row.id],
      }));
    } else {
      this.setState(() => ({
        selected: this.state.selected.filter((x) => x !== row.id),
      }));
    }
  };

  private handleOnSelectAll = (isSelect: boolean, rows: any) => {
    const ids = rows.map((r: any) => r.id);
    if (isSelect) {
      this.setState(() => ({
        selected: ids,
      }));
    } else {
      this.setState(() => ({
        selected: [],
      }));
    }
  };

  private onAddSelectedClicked = () => {
    const data = this.state.list.filter((x) =>
      this.state.selected.includes(x.id)
    ) as IPropertyViewData[];
    const previousState = this.state.previousState as IInstrumentTypeFormData;
    previousState.properties = [];
    data.forEach((item) => {
      previousState.properties.push(item);
    });
    History.replace(CONSTANTS.INSTRUMENTTYPE_CREATE_URL, {
      ...previousState,
    });
  };

  private onCreatePropertyClose = () => {
    this.setState({
      isCreatePropertyOpen: false,
    });
  };

  private onCreatePropertyOpen = () => {
    this.setState({
      propertyName: "",
      propertyCustomId: "",
      propertyUnit: "",
      propertyTypeId: "",
      propertyDecimals: 0,
      propertyDescription: "",
    });
    propertyTypeActions.getAll().then();
  };

  private setPropertyName = (value: string) => {
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      this.setState({
        nameError: false,
        propertyName: value,
      });
    } else {
      this.setState({
        nameError: true,
        propertyName: value,
      });
    }
    this.setState({});
  };

  private setPropertyCustomId = (value: string) => {
    if (value.trim() && /^[0-9]+$/i.test(value)) {
      this.setState({
        propertyCustomId: value,
        customIdError: false,
      });
    } else {
      this.setState({
        propertyCustomId: value,
        customIdError: true,
      });
    }
  };

  private setPropertyDecimals = (value: string) => {
    this.setState({
      propertyDecimals: Number(value),
    });
  };

  private setPropertyUnit = (value: string) => {
    this.setState({
      propertyUnit: value,
    });
  };

  private setPropertyDescriptions = (value: string) => {
    this.setState({
      propertyDescription: value,
    });
  };

  private typeChangeHandler = (e: any) => {
    this.setState({
      propertyTypeId: e.target.value,
    });
  };

  public propertySearch = (val: string) => {
    this.setState({
      propertySearchValue: val,
    });
  };
  private onCancelPropertySelection = () => {
    const previousState = this.state.previousState as IInstrumentTypeFormData;
    History.replace(CONSTANTS.INSTRUMENTTYPE_CREATE_URL, previousState);
  };
  public render() {
    const listData = this.state.list.filter((el: any) =>
      el.name
        .toString()
        .toLowerCase()
        .includes(this.state.propertySearchValue.toString().toLowerCase())
    );
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll">
            <div className="app-container mt-4">
              <div className="container-box rounded-sm rounded-lg submit-header-fixed ml-1">
                <span className="sidebar-main-title font-weight-bold float-left p-2 ml-3">
                  {t(CONSTANTS.ALL_PROPERTIES)}
                </span>
                <span className="float-right">
                  <Button
                    text={t(CONSTANTS.BUTTON_ADD_SELECTED)}
                    disabled={this.state.selected.length === 0}
                    icon="abb/check-mark"
                    type="primary-blue"
                    shape="pill"
                    onClick={this.onAddSelectedClicked}
                  />
                </span>
                <span className="float-right cancel-ins-property">
                  <Button
                    style={{ margin: "0px 4px" }}
                    type="primary-black"
                    shape="pill"
                    className="spinner-position"
                    text={t(CONSTANTS.BUTTON_CANCEL)}
                    icon="abb/close"
                    onClick={this.onCancelPropertySelection}
                  />
                </span>
              </div>
              <TableComponent
                list={listData}
                columns={[
                  {
                    dataField: "name",
                    text: t(CONSTANTS.MODULE_PROPERTY),
                    headerStyle: (colum, colIndex) => {
                      return { textAlign: "left" };
                    },
                    style: {
                      fontWeight: "600",
                    },
                  },
                  {
                    dataField: "customId",
                    text: t(CONSTANTS.LABLE_ID),
                    headerStyle: (colum, colIndex) => {
                      return { width: "10%", textAlign: "left" };
                    },
                  },
                  {
                    dataField: "unit",
                    text: t(CONSTANTS.LABEL_UNIT),
                    headerStyle: (colum, colIndex) => {
                      return { width: "10%", textAlign: "left" };
                    },
                  },
                  {
                    dataField: "description",
                    text: t(CONSTANTS.LABEL_DESCRIPTION),
                    headerStyle: (colum, colIndex) => {
                      return { width: "35%", textAlign: "left" };
                    },
                  },
                  {
                    dataField: "decimal",
                    text: t(CONSTANTS.LABEL_DECIMALS),
                    headerStyle: (colum, colIndex) => {
                      return { width: "10%", textAlign: "left" };
                    },
                  },
                  {
                    dataField: "type",
                    text: t(CONSTANTS.TYPE),
                    headerStyle: (colum, colIndex) => {
                      return { width: "10%", textAlign: "left" };
                    },
                  },
                ]}
                select={true}
                name={t(CONSTANTS.LABEL_PROPERTIES)}
                isAssociation={true}
                associationText={
                  t(CONSTANTS.CREATE) + " " + t(CONSTANTS.MODULE_PROPERTY)
                }
                associationAction={this.onCreatePropertyClick}
                selected={this.state.selected}
                handleOnSelect={this.handleOnSelect}
                handleOnSelectAll={this.handleOnSelectAll}
                propertySearch={this.propertySearch}
                isPropertySearch={true}
                propertySearchValue={this.state.propertySearchValue}
              />
              <Dialog
                isOpen={this.state.isCreatePropertyOpen}
                onOpen={this.onCreatePropertyOpen}
                onClose={this.onCreatePropertyClose}
                showCloseButton={true}
                contentClassName="modal-boxcontent"
                closeOnEscape={true}
                closeOnLostFocus={true}
                dimBackground={true}
                title={
                  t(CONSTANTS.BUTTON_CREATE) + " " + t(CONSTANTS.MENU_PROPERTY)
                }
                standardButtonsOnTop={[
                  {
                    text: t(CONSTANTS.BUTTON_CANCEL),
                    type: "discreet-blue",
                    handler: (dlg) => dlg.close(),
                  },
                  {
                    text: t(CONSTANTS.BUTTON_OK),
                    type: "primary-blue",
                    handler: this.onCreatePropertyOkClick,
                  },
                ]}
              >
                <div className="modal-height overflow-auto w-100">
                  <Input
                    dataType="text"
                    placeholder={t(CONSTANTS.LABLE_NAME)}
                    label={t(CONSTANTS.LABLE_NAME)}
                    required={true}
                    className={
                      this.state.nameError
                        ? "error-code mt-3 w-50"
                        : "mt-3 w-50"
                    }
                    value={this.state.propertyName}
                    onValueChange={this.setPropertyName}
                    showValidationBarWhenInvalid={
                      this.state.nameError ? true : false
                    }
                    description={
                      this.state.nameError
                        ? this.state.propertyName.length
                          ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                          : t(CONSTANTS.FIELD_EMPTY_ERROR)
                        : ""
                    }
                  />
                  <Input
                    dataType="text"
                    placeholder={t(CONSTANTS.LABLE_ID)}
                    label={t(CONSTANTS.LABLE_ID)}
                    required={true}
                    className={
                      this.state.customIdError
                        ? "error-code mt-3 w-50"
                        : "mt-3 w-50"
                    }
                    value={this.state.propertyCustomId}
                    onValueChange={this.setPropertyCustomId}
                    showValidationBarWhenInvalid={
                      this.state.customIdError ? true : false
                    }
                    description={
                      this.state.customIdError
                        ? this.state.propertyCustomId.length
                          ? t(CONSTANTS.PROPERTY_ID_VALIDATION_ERROR)
                          : t(CONSTANTS.FIELD_EMPTY_ERROR)
                        : ""
                    }
                  />
                  <Input
                    dataType="text"
                    placeholder={t(CONSTANTS.LABEL_UNIT)}
                    label={t(CONSTANTS.LABEL_UNIT)}
                    required={false}
                    className="mt-3 w-50"
                    value={this.state.propertyUnit}
                    onValueChange={this.setPropertyUnit}
                  />
                  <Input
                    dataType="number"
                    placeholder={t(CONSTANTS.LABEL_DECIMALS)}
                    label={t(CONSTANTS.LABEL_DECIMALS)}
                    required={false}
                    className="mt-3 w-50"
                    value={String(this.state.propertyDecimals)}
                    onValueChange={this.setPropertyDecimals}
                  />
                  <Input
                    dataType="text"
                    placeholder={t(CONSTANTS.LABEL_TYPE)}
                    label={t(CONSTANTS.LABEL_TYPE)}
                    required={true}
                    className="mt-3 w-50"
                    value={t("Measured")}
                    disabled={true}
                  />
                  <Input
                    dataType="textarea"
                    placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                    label={t(CONSTANTS.LABEL_DESCRIPTION)}
                    required={false}
                    className="mt-3 w-100 mb-4 pr-3"
                    resizable={false}
                    value={this.state.propertyDescription}
                    inputAttributes={{ rows: "4" }}
                    onValueChange={this.setPropertyDescriptions}
                  />
                </div>
              </Dialog>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(AssociateProperty);
